import qs from 'qs'
import fetch from '../utils/Fetch'
import config from '@/config/Config.vue'

//用户修改密码
export function updateUserPhone(data) {
    return fetch({
        url: config.WEB_UPDATEUSERPHONE_API,
        method: 'POST',
        data: qs.stringify(data)
    })
}